$w.onReady(function () {
    console.log("malp")
})